import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
});

// Restaurant Info
export const getRestaurantInfo = async () => {
  try {
    const response = await apiClient.get('/restaurant');
    return response.data;
  } catch (error) {
    console.error('Error fetching restaurant info:', error);
    return null;
  }
};

// Menu Items
export const getMenuItems = async (category = null) => {
  try {
    const params = category && category !== 'Semua' ? { category } : {};
    const response = await apiClient.get('/menu', { params });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Error fetching menu:', error);
    return [];
  }
};

export const getMenuCategories = async () => {
  try {
    const response = await apiClient.get('/menu/categories');
    return Array.isArray(response.data) ? response.data : ['Semua'];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return ['Semua'];
  }
};

// Reviews
export const getReviews = async () => {
  try {
    const response = await apiClient.get('/reviews');
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Error fetching reviews:', error);
    return [];
  }
};

// About Content
export const getAboutContent = async () => {
  try {
    const response = await apiClient.get('/about');
    return response.data;
  } catch (error) {
    console.error('Error fetching about:', error);
    return null;
  }
};

export default apiClient;
